import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-199d611a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-global batch-page" }
const _hoisted_2 = { class: "batch-header" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "batch-subtitle" }
const _hoisted_5 = {
  class: "batch-steps",
  "aria-label": "Progress"
}
const _hoisted_6 = {
  key: 0,
  class: "batch-alert batch-alert--error",
  role: "alert"
}
const _hoisted_7 = {
  key: 1,
  class: "batch-section space-y-6"
}
const _hoisted_8 = { class: "batch-grid batch-grid--two" }
const _hoisted_9 = { class: "batch-field" }
const _hoisted_10 = { class: "batch-field" }
const _hoisted_11 = { class: "batch-field" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 0 }, null, -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "batch-field" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 0 }, null, -1))
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 0,
  class: "batch-field"
}
const _hoisted_18 = {
  key: 1,
  class: "batch-field"
}
const _hoisted_19 = {
  key: 0,
  class: "batch-panel"
}
const _hoisted_20 = { class: "batch-help" }
const _hoisted_21 = {
  key: 0,
  class: "batch-field batch-field--wide"
}
const _hoisted_22 = {
  key: 1,
  class: "batch-processes"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_25 = { value: true }
const _hoisted_26 = { value: false }
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = { value: "TARGET_USER" }
const _hoisted_29 = {
  key: 0,
  value: "DEFAULT_EXECUTORS"
}
const _hoisted_30 = {
  key: 2,
  class: "batch-empty"
}
const _hoisted_31 = {
  key: 1,
  class: "batch-panel batch-source-panel"
}
const _hoisted_32 = { class: "batch-source-tabs" }
const _hoisted_33 = {
  key: 0,
  class: "batch-field"
}
const _hoisted_34 = { key: 1 }
const _hoisted_35 = {
  key: 0,
  class: "batch-uploaded-files"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 2,
  class: "batch-grid batch-grid--two"
}
const _hoisted_38 = { class: "batch-panel batch-source-panel" }
const _hoisted_39 = { class: "batch-source-tabs" }
const _hoisted_40 = {
  key: 0,
  class: "batch-field"
}
const _hoisted_41 = { value: 0 }
const _hoisted_42 = ["value"]
const _hoisted_43 = { key: 1 }
const _hoisted_44 = {
  key: 0,
  class: "batch-uploaded-files"
}
const _hoisted_45 = { class: "batch-panel batch-source-panel" }
const _hoisted_46 = { class: "batch-source-tabs" }
const _hoisted_47 = {
  key: 0,
  class: "batch-field"
}
const _hoisted_48 = { key: 1 }
const _hoisted_49 = {
  key: 0,
  class: "batch-uploaded-files"
}
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "batch-grid batch-grid--two" }
const _hoisted_52 = { class: "batch-field batch-field--wide" }
const _hoisted_53 = {
  key: 3,
  class: "batch-package-hint"
}
const _hoisted_54 = { class: "batch-checkbox" }
const _hoisted_55 = { class: "batch-summary" }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = {
  key: 2,
  class: "batch-section space-y-6"
}
const _hoisted_58 = {
  key: 0,
  class: "batch-panel"
}
const _hoisted_59 = { class: "batch-panel-title" }
const _hoisted_60 = { class: "batch-help" }
const _hoisted_61 = { class: "batch-scope-list" }
const _hoisted_62 = ["onUpdate:modelValue"]
const _hoisted_63 = { value: "COMMON" }
const _hoisted_64 = { value: "INDIVIDUAL" }
const _hoisted_65 = {
  key: 1,
  class: "batch-panel"
}
const _hoisted_66 = { class: "batch-grid batch-grid--three" }
const _hoisted_67 = {
  key: 2,
  class: "batch-panel"
}
const _hoisted_68 = { class: "batch-help" }
const _hoisted_69 = { class: "batch-table-wrap" }
const _hoisted_70 = { class: "batch-table" }
const _hoisted_71 = { class: "batch-table__user" }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { class: "batch-table__user" }
const _hoisted_74 = {
  key: 3,
  class: "batch-panel"
}
const _hoisted_75 = { class: "batch-help" }
const _hoisted_76 = { class: "batch-grid batch-grid--two" }
const _hoisted_77 = { class: "batch-template-label" }
const _hoisted_78 = {
  key: 0,
  class: "batch-file-role"
}
const _hoisted_79 = ["onUpdate:modelValue"]
const _hoisted_80 = {
  key: 4,
  class: "batch-panel"
}
const _hoisted_81 = { class: "batch-help" }
const _hoisted_82 = { class: "batch-field batch-preview-employee" }
const _hoisted_83 = ["value"]
const _hoisted_84 = { class: "batch-preview-list" }
const _hoisted_85 = {
  key: 0,
  class: "batch-file-role"
}
const _hoisted_86 = {
  key: 5,
  class: "batch-panel"
}
const _hoisted_87 = { class: "batch-help" }
const _hoisted_88 = { class: "batch-uploaded-files batch-uploaded-files--readonly" }
const _hoisted_89 = {
  key: 3,
  class: "batch-section space-y-6"
}
const _hoisted_90 = { class: "batch-panel" }
const _hoisted_91 = { class: "batch-review" }
const _hoisted_92 = {
  key: 0,
  class: "batch-panel"
}
const _hoisted_93 = { class: "batch-progress-title" }
const _hoisted_94 = ["aria-valuenow"]
const _hoisted_95 = { class: "batch-result-counts" }
const _hoisted_96 = { class: "success" }
const _hoisted_97 = {
  key: 0,
  class: "failure"
}
const _hoisted_98 = {
  key: 0,
  class: "batch-failures"
}
const _hoisted_99 = {
  key: 1,
  class: "batch-alert batch-alert--success"
}
const _hoisted_100 = { class: "batch-actions" }
const _hoisted_101 = { class: "batch-preview-meta" }
const _hoisted_102 = { class: "batch-preview-actions" }
const _hoisted_103 = { class: "mb-3 text-gray-700" }
const _hoisted_104 = { class: "mb-6 text-sm text-gray-500" }
const _hoisted_105 = { class: "flex flex-wrap gap-3" }

import {
  computed,
  defineComponent,
  h,
  nextTick,
  onBeforeUnmount,
  onMounted,
  PropType,
  reactive,
  ref,
} from "vue";
import { useRouter } from "vue-router";
import Multiselect from "@vueform/multiselect";
import Editor from "@tinymce/tinymce-vue";
import Modal from "@/components/common/Modal.vue";
import { t, getLocale } from "@/i18n";
import DocumentDataService from "@/services/documents/document/DocumentDataService";
import DocumentBatchDataService from "@/services/documents/document/DocumentBatchDataService";
import DocumentTemplateDataService from "@/services/documents/documentTemplate/DocumentTemplateDataService";
import DocumentConstructorDataService from "@/services/documents/DocumentConstructor/DocumentConstructorDataService";
import DocumentConstructor from "@/types/documents/documentConstructor/DocumentConstructor";
import ConstructorProcess from "@/types/documents/documentConstructor/Process";
import Nomenclature from "@/types/documents/nomenclature/Nomenclature";
import DocumentCreate from "@/types/documents/document/DocumentCreate";
import {
  DocumentBatchUserProfile,
  DocumentBatchItemRequest,
} from "@/types/documents/documentBatch/DocumentBatch";
import {
  BatchFieldScope,
  BatchFieldValue,
  BatchFieldValues,
  BatchLogicalField,
  BatchTemplate,
  buildProfileValues,
  buildTemplateFieldConfig,
  createLogicalFields,
  findUnresolvedTemplateTags,
  formatTemplateFieldValue,
  isEmptyBatchValue,
  resolveDocumentTitle,
  validateTemplateValues,
} from "@/utils/documentBatchFields";
import { filterDocumentTemplatesByNomenclature } from "@/utils/documentTemplateFilter";
import { fullTinyMceConfig, tinyMceScriptSrc } from "@/utils/tinymceConfig";
import DocumentUploadZone from "@/components/common/DocumentUploadZone.vue";

interface BatchConfig {
  name: string;
  constructorId: string;
  nomenclatureId: string;
  templateIds: string[];
  mainTemplateId: string;
  additionalTemplateIds: string[];
  userIds: string[];
  deadline: string;
  description: string;
  price: string;
  sendForExecution: boolean;
}

interface CreationTaskResult {
  itemKey: string;
  userId: string;
  userName: string;
  templateId: string | null;
  templateIds: string[];
  templateName: string;
  uploadedMainKey: string | null;
  uploadedAdditionalKeys: string[];
  status: "PENDING" | "SUCCESS" | "FAILED";
  error: string;
  fileGuids: Record<string, string>;
}

type BatchSourceMode = "TEMPLATE" | "UPLOAD";
type UploadTarget = "STANDALONE" | "MAIN" | "ADDITIONAL";

interface BatchUploadedFile {
  key: string;
  name: string;
  size: number;
  fingerprint: string;
  source: File;
}

interface BatchPreviewDraft {
  profileId: string;
  templateId: string;
  html: string;
  generatedHtml: string;
  fieldSnapshot: string;
  manuallyEdited: boolean;
}

type PreviewConflictChoice = "KEEP" | "REBUILD" | null;

interface ProcessTemplateOption {
  id: string;
  name?: string;
  nameI18n?: Record<string, string>;
}

interface IdNameOption {
  id: string;
  name: string;
}

interface UserOption {
  id: string;
  fullName: string;
}

interface PagedResponse<T> {
  data: {
    data: {
      items?: T[];
      pager?: { currentPage?: number; totalPages?: number };
    };
  };
}

interface BatchConfiguredProcess extends ConstructorProcess {
  batchKey: string;
  isFreeInstance: boolean;
  templateId: string;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const BatchFieldInput = defineComponent({
  name: "BatchFieldInput",
  props: {
    modelValue: {
      type: [String, Array] as PropType<BatchFieldValue>,
      default: "",
    },
    field: { type: Object as PropType<BatchLogicalField>, required: true },
    compact: { type: Boolean, default: false },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    return () => {
      const field = props.field;
      const attrs = {
        value: props.modelValue,
        class: [
          "batch-dynamic-input",
          props.compact ? "batch-dynamic-input--compact" : "",
        ],
        onInput: (event: Event) =>
          emit("update:modelValue", (event.target as HTMLInputElement).value),
      };
      let control;
      if (field.type === "SELECT") {
        control = h("select", attrs, [
          h("option", { value: "" }),
          ...field.options.map((option) =>
            h("option", { value: option.value }, option.label)
          ),
        ]);
      } else if (field.type === "MULTI_SELECT") {
        control = h(
          "select",
          {
            ...attrs,
            multiple: true,
            value: Array.isArray(props.modelValue) ? props.modelValue : [],
            onChange: (event: Event) =>
              emit(
                "update:modelValue",
                Array.from(
                  (event.target as HTMLSelectElement).selectedOptions
                ).map((option) => option.value)
              ),
          },
          field.options.map((option) =>
            h("option", { value: option.value }, option.label)
          )
        );
      } else if (field.type === "TEXTAREA") {
        control = h("textarea", {
          ...attrs,
          rows: props.compact ? 2 : 3,
        });
      } else {
        control = h("input", {
          ...attrs,
          type:
            field.type === "DATE"
              ? "date"
              : field.type === "DATETIME"
              ? "datetime-local"
              : "text",
        });
      }
      if (props.compact) return control;
      return h("label", { class: "batch-field" }, [
        h("span", `${field.label}${field.required ? " *" : ""}`),
        control,
        h("small", field.templateNames.join(", ")),
      ]);
    };
  },
});

const router = useRouter();
const step = ref(1);
const pageError = ref("");
const isLoading = ref(false);
const isCreating = ref(false);
const batchId = ref<string | null>(null);
const batchKey = createUuid();
const constructors = ref<IdNameOption[]>([]);
const nomenclatures = ref<Nomenclature[]>([]);
const templates = ref<BatchTemplate[]>([]);
const processTemplates = ref<ProcessTemplateOption[]>([]);
const constructorInfo = ref<DocumentConstructor | null>(null);
const userOptions = ref<UserOption[]>([]);
const usersMultiselect = ref<{ $el: HTMLElement } | null>(null);
const isUsersLoading = ref(false);
const usersCurrentPage = ref(0);
const usersTotalPages = ref(1);
const usersSearchQuery = ref("");
const standaloneSourceMode = ref<BatchSourceMode>("TEMPLATE");
const mainSourceMode = ref<BatchSourceMode>("TEMPLATE");
const additionalSourceMode = ref<BatchSourceMode>("TEMPLATE");
const uploadedStandaloneFiles = ref<BatchUploadedFile[]>([]);
const uploadedMainFile = ref<BatchUploadedFile | null>(null);
const uploadedAdditionalFiles = ref<BatchUploadedFile[]>([]);
const profiles = ref<DocumentBatchUserProfile[]>([]);
const logicalFields = ref<BatchLogicalField[]>([]);
const commonValues = reactive<BatchFieldValues>({});
const individualValues = reactive<Record<string, BatchFieldValues>>({});
const fieldScopes = reactive<Record<string, BatchFieldScope>>({});
const titlePatterns = reactive<Record<string, string>>({});
const processAssignments = reactive<
  Record<string, "TARGET_USER" | "DEFAULT_EXECUTORS">
>({});
const selectedFreeProcessKeys = ref<string[]>([]);
const freeProcessQueueModes = reactive<Record<string, boolean>>({});
const results = ref<CreationTaskResult[]>([]);
const previewProfileId = ref<string | null>(null);
const previewModalIsOpen = ref(false);
const previewHtml = ref("");
const activePreviewKey = ref("");
const previewDocumentTitle = ref("");
const previewTemplateName = ref("");
const previewEmployeeName = ref("");
const showPreviewConflictModal = ref(false);
const preparedConfigurationSignature = ref("");
const previewDrafts = new Map<string, BatchPreviewDraft>();
const batchPreviewEditorConfig = {
  ...fullTinyMceConfig,
  height: 560,
};
let previewConflictResolve: ((choice: PreviewConflictChoice) => void) | null =
  null;
let usersSearchTimer: ReturnType<typeof setTimeout> | null = null;
let usersRequestVersion = 0;
let usersScrollContainer: HTMLElement | null = null;
let usersScrollFrame: number | null = null;
const USERS_SCROLL_THRESHOLD_PX = 48;

const now = new Date();
const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
  2,
  "0"
)}-${String(now.getDate()).padStart(2, "0")}`;

const config = reactive<BatchConfig>({
  name: `${t("documentBatch.defaultName")} ${today}`,
  constructorId: "",
  nomenclatureId: "",
  templateIds: [],
  mainTemplateId: "",
  additionalTemplateIds: [],
  userIds: [],
  deadline: "",
  description: "",
  price: "",
  sendForExecution: true,
});

const freeProcessOptions = computed(() =>
  (constructorInfo.value?.process || [])
    .filter((process) => process.processMode === "FREE")
    .flatMap((process) =>
      (process.freeTemplateIds || []).map((templateId) => ({
        value: `${process.processGuid}:${templateId}`,
        label: resolveProcessTemplateName(templateId),
      }))
    )
);
const configuredProcesses = computed<BatchConfiguredProcess[]>(() => {
  const mandatory = (constructorInfo.value?.process || [])
    .filter((process) => process.processMode !== "FREE" && process.templateId)
    .map((process) => ({
      ...process,
      batchKey: process.processGuid,
      isFreeInstance: false,
      templateId: String(process.templateId),
    }));
  const free = selectedFreeProcessKeys.value
    .map((key) => {
      const separator = key.lastIndexOf(":");
      const processGuid = key.slice(0, separator);
      const templateId = key.slice(separator + 1);
      const source = (constructorInfo.value?.process || []).find(
        (process) =>
          process.processGuid === processGuid &&
          process.processMode === "FREE" &&
          process.freeTemplateIds?.includes(templateId)
      );
      if (!source || !templateId) return null;
      return {
        ...source,
        batchKey: key,
        isFreeInstance: true,
        templateId,
        templateName: resolveProcessTemplateName(templateId),
      } as BatchConfiguredProcess;
    })
    .filter((process): process is BatchConfiguredProcess => Boolean(process));
  return [...mandatory, ...free];
});
const targetProcess = computed(() =>
  configuredProcesses.value.find(
    (process) => processAssignments[process.batchKey] === "TARGET_USER"
  )
);
const hasMoreUsers = computed(
  () => usersCurrentPage.value < usersTotalPages.value
);
const selectedNomenclature = computed(() =>
  nomenclatures.value.find((item) => item.id === config.nomenclatureId)
);
const isPackageMode = computed(() =>
  Boolean(
    constructorInfo.value?.params?.subFile?.isSelected ||
      constructorInfo.value?.params?.subFile?.isRequired
  )
);
const availableTemplates = computed(() =>
  filterDocumentTemplatesByNomenclature(
    templates.value,
    selectedNomenclature.value
  )
);
const availableAdditionalTemplates = computed(() =>
  availableTemplates.value.filter(
    (template) => template.id !== config.mainTemplateId
  )
);
const selectedTemplateIds = computed(() => {
  if (!isPackageMode.value) {
    return standaloneSourceMode.value === "TEMPLATE"
      ? [...config.templateIds]
      : [];
  }
  const ids = [
    mainSourceMode.value === "TEMPLATE" ? config.mainTemplateId : "",
    ...(additionalSourceMode.value === "TEMPLATE"
      ? [...config.additionalTemplateIds]
      : []),
  ].filter(Boolean);
  return Array.from(new Set(ids));
});
const selectedTemplates = computed(() =>
  selectedTemplateIds.value
    .map((id) =>
      templates.value.find((template) => String(template.id) === String(id))
    )
    .filter((template): template is BatchTemplate => Boolean(template))
);
const selectedMainTemplate = computed(() =>
  isPackageMode.value && mainSourceMode.value === "TEMPLATE"
    ? selectedTemplates.value.find(
        (template) => String(template.id) === String(config.mainTemplateId)
      ) || null
    : null
);
const activeStandaloneFileCount = computed(() =>
  standaloneSourceMode.value === "UPLOAD"
    ? uploadedStandaloneFiles.value.length
    : 0
);
const activeAdditionalFileCount = computed(() =>
  additionalSourceMode.value === "UPLOAD"
    ? uploadedAdditionalFiles.value.length
    : 0
);
const hasMainSource = computed(() =>
  mainSourceMode.value === "TEMPLATE"
    ? Boolean(config.mainTemplateId)
    : Boolean(uploadedMainFile.value)
);
const activeUploadedFiles = computed(() => {
  if (!isPackageMode.value) {
    return standaloneSourceMode.value === "UPLOAD"
      ? uploadedStandaloneFiles.value
      : [];
  }
  return [
    ...(mainSourceMode.value === "UPLOAD" && uploadedMainFile.value
      ? [uploadedMainFile.value]
      : []),
    ...(additionalSourceMode.value === "UPLOAD"
      ? uploadedAdditionalFiles.value
      : []),
  ];
});
const totalDocuments = computed(
  () =>
    config.userIds.length *
    (isPackageMode.value
      ? hasMainSource.value
        ? 1
        : 0
      : selectedTemplateIds.value.length + activeStandaloneFileCount.value)
);
const totalFiles = computed(
  () =>
    config.userIds.length *
    (isPackageMode.value
      ? (hasMainSource.value ? 1 : 0) +
        selectedTemplateIds.value.length -
        (selectedMainTemplate.value ? 1 : 0) +
        activeAdditionalFileCount.value
      : selectedTemplateIds.value.length + activeStandaloneFileCount.value)
);
const commonFields = computed(() =>
  logicalFields.value.filter((field) => fieldScopes[field.key] === "COMMON")
);
const individualFields = computed(() =>
  logicalFields.value.filter((field) => fieldScopes[field.key] === "INDIVIDUAL")
);
const completedCount = computed(
  () => results.value.filter((result) => result.status !== "PENDING").length
);
const successCount = computed(
  () => results.value.filter((result) => result.status === "SUCCESS").length
);
const failedResults = computed(() =>
  results.value.filter((result) => result.status === "FAILED")
);
const failureCount = computed(() => failedResults.value.length);
const progressPercent = computed(() =>
  totalDocuments.value
    ? Math.round((completedCount.value / totalDocuments.value) * 100)
    : 0
);
const creationFinished = computed(
  () =>
    results.value.length > 0 &&
    completedCount.value === results.value.length &&
    !isCreating.value
);

onMounted(async () => {
  isLoading.value = true;
  try {
    const [
      allConstructors,
      allNomenclatures,
      allTemplates,
      allProcessTemplates,
    ] = await Promise.all([
      loadAllPagedItems<IdNameOption>(
        DocumentDataService.getConstructors.bind(DocumentDataService)
      ),
      loadAllPagedItems<Nomenclature & { id: string }>(
        DocumentDataService.getNomenclatures.bind(DocumentDataService)
      ),
      loadAllTemplates(),
      loadAllPagedItems<ProcessTemplateOption>(
        DocumentConstructorDataService.getTemplates.bind(
          DocumentConstructorDataService
        )
      ),
    ]);
    constructors.value = allConstructors;
    nomenclatures.value = allNomenclatures;
    templates.value = allTemplates;
    processTemplates.value = allProcessTemplates;
  } catch (error) {
    pageError.value = extractError(error, t("documentBatch.loadError"));
  } finally {
    isLoading.value = false;
  }
});

onBeforeUnmount(() => {
  resolvePreviewConflict(null);
  previewDrafts.clear();
  clearUsersSearchTimer();
  detachUsersScrollListener();
  usersRequestVersion += 1;
});

async function loadAllPagedItems<T extends { id: string }>(
  loader: (params: { page: number }) => Promise<PagedResponse<T>>
): Promise<T[]> {
  const all = new Map<string, T>();
  let page = 1;
  let totalPages = 1;
  do {
    const response = await loader({ page });
    const data = response.data.data;
    (data.items || []).forEach((item) => {
      if (item.id) all.set(item.id, item);
    });
    totalPages = Math.min(Number(data.pager?.totalPages || 1), 100);
    page += 1;
  } while (page <= totalPages);
  return Array.from(all.values());
}

async function loadAllTemplates() {
  const all = new Map<string, BatchTemplate>();
  let page = 1;
  let totalPages = 1;
  do {
    const response = await DocumentTemplateDataService.getAll({ page });
    const data = response.data.data;
    (data.items || []).forEach((item: BatchTemplate) => {
      if (item.id && item.status === "ACTIVE") all.set(item.id, item);
    });
    totalPages = Math.min(Number(data.pager?.totalPages || 1), 100);
    page += 1;
  } while (page <= totalPages);
  return Array.from(all.values()).sort((left, right) =>
    left.name.localeCompare(right.name)
  );
}

async function onConstructorChange() {
  pageError.value = "";
  constructorInfo.value = null;
  config.userIds = [];
  resetUsersPagination();
  selectedFreeProcessKeys.value = [];
  Object.keys(processAssignments).forEach(
    (key) => delete processAssignments[key]
  );
  Object.keys(freeProcessQueueModes).forEach(
    (key) => delete freeProcessQueueModes[key]
  );
  if (!config.constructorId) return;
  try {
    const response = await DocumentDataService.getConstructorInfo(
      config.constructorId
    );
    constructorInfo.value = response.data.data;
    configuredProcesses.value.forEach((process) => {
      processAssignments[process.batchKey] = hasDefaultExecutors(process)
        ? "DEFAULT_EXECUTORS"
        : "TARGET_USER";
    });
    if (!targetProcess.value && configuredProcesses.value.length) {
      processAssignments[configuredProcesses.value[0].batchKey] = "TARGET_USER";
    }
    await searchUsers("");
  } catch (error) {
    pageError.value = extractError(error, t("documentBatch.categoryLoadError"));
  }
}

function resolveProcessTemplateName(templateId: string) {
  const template = processTemplates.value.find(
    (item) => item.id === templateId
  );
  const locale = getLocale();
  return (
    template?.nameI18n?.[locale] ||
    template?.nameI18n?.ru ||
    template?.nameI18n?.en ||
    template?.name ||
    `${t("docForm.process")} #${templateId}`
  );
}

function onFreeProcessesChange() {
  const activeKeys = new Set(
    configuredProcesses.value.map((item) => item.batchKey)
  );
  Object.keys(processAssignments).forEach((key) => {
    if (!activeKeys.has(key)) delete processAssignments[key];
  });
  Object.keys(freeProcessQueueModes).forEach((key) => {
    if (!activeKeys.has(key)) delete freeProcessQueueModes[key];
  });
  configuredProcesses.value.forEach((process) => {
    if (!processAssignments[process.batchKey]) {
      processAssignments[process.batchKey] = hasDefaultExecutors(process)
        ? "DEFAULT_EXECUTORS"
        : "TARGET_USER";
    }
    if (
      process.isFreeInstance &&
      !(process.batchKey in freeProcessQueueModes)
    ) {
      freeProcessQueueModes[process.batchKey] = false;
    }
  });
  if (!targetProcess.value && configuredProcesses.value.length) {
    processAssignments[configuredProcesses.value[0].batchKey] = "TARGET_USER";
  }
  onProcessAssignmentChange();
}

function hasDefaultExecutors(process: ConstructorProcess) {
  return Boolean(
    process.executorUserIds?.length ||
      process.executorJobIds?.length ||
      process.executorCompanyIds?.length
  );
}

function onProcessAssignmentChange() {
  config.userIds = [];
  resetUsersPagination();
  searchUsers("");
}

function clearUsersSearchTimer() {
  if (usersSearchTimer !== null) {
    clearTimeout(usersSearchTimer);
    usersSearchTimer = null;
  }
}

function resetUsersPagination() {
  clearUsersSearchTimer();
  usersRequestVersion += 1;
  isUsersLoading.value = false;
  usersCurrentPage.value = 0;
  usersTotalPages.value = 1;
  usersSearchQuery.value = "";
  userOptions.value = [];
}

function ensureUsersLoaded() {
  if (!userOptions.value.length && !isUsersLoading.value) {
    searchUsers("");
  }
}

function onUsersOpen() {
  ensureUsersLoaded();
  void nextTick(() => {
    attachUsersScrollListener();
    checkUsersScrollPosition();
  });
}

function attachUsersScrollListener() {
  const container = usersMultiselect.value?.$el.querySelector<HTMLElement>(
    ".multiselect-dropdown"
  );
  if (!container || container === usersScrollContainer) return;
  detachUsersScrollListener();
  usersScrollContainer = container;
  usersScrollContainer.addEventListener("scroll", onUsersScroll, {
    passive: true,
  });
}

function detachUsersScrollListener() {
  usersScrollContainer?.removeEventListener("scroll", onUsersScroll);
  usersScrollContainer = null;
  if (usersScrollFrame !== null) {
    window.cancelAnimationFrame(usersScrollFrame);
    usersScrollFrame = null;
  }
}

function onUsersScroll() {
  if (usersScrollFrame !== null) return;
  usersScrollFrame = window.requestAnimationFrame(() => {
    usersScrollFrame = null;
    checkUsersScrollPosition();
  });
}

function checkUsersScrollPosition() {
  if (!usersScrollContainer || isUsersLoading.value || !hasMoreUsers.value) {
    return;
  }
  const remainingScroll =
    usersScrollContainer.scrollHeight -
    usersScrollContainer.scrollTop -
    usersScrollContainer.clientHeight;
  if (remainingScroll <= USERS_SCROLL_THRESHOLD_PX) {
    void loadUsersPage(
      usersCurrentPage.value + 1,
      usersSearchQuery.value,
      false
    );
  }
}

function onUserSearchChange(query: string | null) {
  const normalizedQuery = String(query || "").trim();
  clearUsersSearchTimer();
  usersSearchTimer = setTimeout(() => {
    usersSearchTimer = null;
    if (normalizedQuery !== usersSearchQuery.value) {
      searchUsers(normalizedQuery);
    }
  }, 250);
}

async function searchUsers(query = "") {
  if (!config.constructorId || !targetProcess.value) return;
  clearUsersSearchTimer();
  const normalizedQuery = query.trim();
  usersSearchQuery.value = normalizedQuery;
  usersCurrentPage.value = 0;
  usersTotalPages.value = 1;
  await loadUsersPage(1, normalizedQuery, true);
}

async function loadUsersPage(page: number, query: string, replace: boolean) {
  if (!config.constructorId || !targetProcess.value) return;
  const requestVersion = replace ? ++usersRequestVersion : usersRequestVersion;
  isUsersLoading.value = true;
  try {
    const response = await DocumentDataService.getProcessUserFilter({
      constructorId: config.constructorId,
      processGuid: targetProcess.value.processGuid,
      page,
      name: query || undefined,
    });
    if (
      requestVersion !== usersRequestVersion ||
      query !== usersSearchQuery.value
    ) {
      return;
    }
    const selectedIds = new Set(config.userIds.map(String));
    const initialOptions = replace
      ? userOptions.value.filter((item) => selectedIds.has(String(item.id)))
      : userOptions.value;
    const merged = new Map(initialOptions.map((item) => [item.id, item]));
    (response.data.data.items || []).forEach((item: UserOption) =>
      merged.set(item.id, item)
    );
    userOptions.value = Array.from(merged.values());
    usersCurrentPage.value = page;
    usersTotalPages.value = Number(response.data.data.pager?.totalPages || 0);
  } catch (error) {
    if (requestVersion === usersRequestVersion) {
      pageError.value = extractError(error, t("documentBatch.usersLoadError"));
    }
  } finally {
    if (requestVersion === usersRequestVersion) {
      isUsersLoading.value = false;
      void nextTick(checkUsersScrollPosition);
    }
  }
}

function resetUnavailableTemplates() {
  const allowed = new Set(
    availableTemplates.value.map((template) => template.id)
  );
  config.templateIds = config.templateIds.filter((id) => allowed.has(id));
  if (!allowed.has(config.mainTemplateId)) {
    config.mainTemplateId = 0;
  }
  config.additionalTemplateIds = config.additionalTemplateIds.filter(
    (id) => allowed.has(id) && id !== config.mainTemplateId
  );
}

function nomenclatureOptionLabel(item: Nomenclature) {
  const index = String(item.index || "").trim();
  return index ? `${item.name} (${index})` : item.name;
}

function onMainTemplateChange() {
  config.additionalTemplateIds = config.additionalTemplateIds.filter(
    (id) => String(id) !== String(config.mainTemplateId)
  );
}

function targetFiles(target: UploadTarget) {
  if (target === "ADDITIONAL") return uploadedAdditionalFiles.value;
  if (target === "STANDALONE") return uploadedStandaloneFiles.value;
  return uploadedMainFile.value ? [uploadedMainFile.value] : [];
}

function fileFingerprint(file: File) {
  return `${file.name}:${file.size}:${file.lastModified}`;
}

function addSelectedFiles(files: File[], target: UploadTarget) {
  if (!files.length) return;
  const existing = new Set(targetFiles(target).map((file) => file.fingerprint));
  const candidates = (target === "MAIN" ? files.slice(0, 1) : files).filter(
    (file) => !existing.has(fileFingerprint(file))
  );
  for (const file of candidates) {
    const selected: BatchUploadedFile = {
      key: createUuid(),
      name: file.name,
      size: file.size,
      fingerprint: fileFingerprint(file),
      source: file,
    };
    if (target === "MAIN") {
      uploadedMainFile.value = selected;
    } else if (target === "ADDITIONAL") {
      uploadedAdditionalFiles.value.push(selected);
    } else {
      uploadedStandaloneFiles.value.push(selected);
    }
    existing.add(selected.fingerprint);
  }
}

function removeUploadedFile(target: UploadTarget, key: string) {
  if (target === "MAIN") {
    if (uploadedMainFile.value?.key === key) uploadedMainFile.value = null;
    return;
  }
  const files =
    target === "ADDITIONAL"
      ? uploadedAdditionalFiles.value
      : uploadedStandaloneFiles.value;
  const index = files.findIndex((file) => file.key === key);
  if (index >= 0) files.splice(index, 1);
}

function formatFileSize(size: number) {
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
}

function templateRoleLabel(template: BatchTemplate) {
  return String(template.id) === String(config.mainTemplateId)
    ? t("documentBatch.mainFile")
    : t("documentBatch.additionalFile");
}

async function nextStep() {
  pageError.value = "";
  if (step.value === 1) {
    const validation = validateConfiguration();
    if (validation) {
      pageError.value = validation;
      return;
    }
    const configurationSignature = createStepTwoConfigurationSignature();
    if (
      preparedConfigurationSignature.value &&
      preparedConfigurationSignature.value === configurationSignature
    ) {
      step.value = 2;
      return;
    }
    if (
      preparedConfigurationSignature.value &&
      !window.confirm(t("documentBatch.resetFieldsConfirm"))
    ) {
      return;
    }
    if (preparedConfigurationSignature.value) {
      resetStepTwoState();
    }
    isLoading.value = true;
    try {
      await prepareFields();
      preparedConfigurationSignature.value = configurationSignature;
      step.value = 2;
    } catch (error) {
      pageError.value = extractError(error, t("documentBatch.prepareError"));
    } finally {
      isLoading.value = false;
    }
    return;
  }
  const fieldError = validateAllFields();
  if (fieldError) {
    pageError.value = fieldError;
    return;
  }
  if (!(await resolveStalePreviewDrafts())) {
    return;
  }
  step.value = 3;
}

function previousStep() {
  pageError.value = "";
  step.value -= 1;
}

function createStepTwoConfigurationSignature() {
  const sortedIds = (ids: string[]) => [...ids].sort();
  const sortedFileKeys = (files: BatchUploadedFile[]) =>
    files.map((file) => file.key).sort();
  return JSON.stringify({
    constructorId: config.constructorId,
    nomenclatureId: config.nomenclatureId,
    packageMode: isPackageMode.value,
    standaloneSourceMode: standaloneSourceMode.value,
    mainSourceMode: mainSourceMode.value,
    additionalSourceMode: additionalSourceMode.value,
    templateIds: isPackageMode.value ? [] : sortedIds(config.templateIds),
    mainTemplateId: isPackageMode.value ? config.mainTemplateId : "",
    additionalTemplateIds: isPackageMode.value
      ? sortedIds(config.additionalTemplateIds)
      : [],
    uploadedStandaloneFiles: isPackageMode.value
      ? []
      : sortedFileKeys(uploadedStandaloneFiles.value),
    uploadedMainFile: isPackageMode.value
      ? uploadedMainFile.value?.key || null
      : null,
    uploadedAdditionalFiles: isPackageMode.value
      ? sortedFileKeys(uploadedAdditionalFiles.value)
      : [],
    userIds: sortedIds(config.userIds),
    processes: configuredProcesses.value.map((process) => ({
      key: process.batchKey,
      templateId: process.templateId,
      assignment: processAssignments[process.batchKey] || "",
      queueMode: process.isFreeInstance
        ? Boolean(freeProcessQueueModes[process.batchKey])
        : null,
    })),
  });
}

function resetStepTwoState() {
  profiles.value = [];
  logicalFields.value = [];
  Object.keys(commonValues).forEach((key) => delete commonValues[key]);
  Object.keys(individualValues).forEach((key) => delete individualValues[key]);
  Object.keys(fieldScopes).forEach((key) => delete fieldScopes[key]);
  Object.keys(titlePatterns).forEach((key) => delete titlePatterns[key]);
  previewProfileId.value = null;
  resetTemplatePreviewState();
  preparedConfigurationSignature.value = "";
}

function validateConfiguration() {
  if (
    !config.name ||
    !config.constructorId ||
    !config.nomenclatureId ||
    !config.deadline
  ) {
    return t("documentBatch.requiredConfiguration");
  }
  if (!config.userIds.length) {
    return t("documentBatch.requiredSelections");
  }
  if (!isPackageMode.value) {
    const hasSource =
      standaloneSourceMode.value === "TEMPLATE"
        ? config.templateIds.length > 0
        : uploadedStandaloneFiles.value.length > 0;
    if (!hasSource) return t("documentBatch.documentSourceRequired");
  }
  if (isPackageMode.value) {
    if (!hasMainSource.value) {
      return t("documentBatch.mainSourceRequired");
    }
    const hasAdditionalSource =
      additionalSourceMode.value === "TEMPLATE"
        ? config.additionalTemplateIds.length > 0
        : uploadedAdditionalFiles.value.length > 0;
    if (!hasAdditionalSource) {
      return t("documentBatch.additionalSourceRequired");
  }
  }
  if (!targetProcess.value) return t("documentBatch.targetProcessRequired");
  if (totalDocuments.value > 500) return t("documentBatch.limitExceeded");
  if (totalFiles.value > 500) return t("documentBatch.fileLimitExceeded");
  if (config.deadline < today) return t("documentBatch.deadlinePast");
  const params = constructorInfo.value?.params;
  if (
    isPackageMode.value &&
    (!params?.mainFile?.isSelected || !params?.subFile?.isSelected)
  ) {
    return t("documentBatch.packageCategoryUnsupported");
  }
  if (params?.description?.isRequired && !config.description)
    return t("documentBatch.descriptionRequired");
  if (params?.price?.isRequired && !config.price)
    return t("documentBatch.priceRequired");
  const esedo = params?.esedoConfig;
  if (esedo?.enabled && esedo.counterpartySelectionMode !== "NOT_USED") {
    return t("documentBatch.esedoUnsupported");
  }
  return "";
}

async function prepareFields() {
  if (!targetProcess.value) {
    throw new Error(t("documentBatch.targetProcessRequired"));
  }
  const profileResponse = await DocumentBatchDataService.getProfiles({
    constructorId: config.constructorId,
    processGuids: Array.from(
      new Set(
        configuredProcesses.value
          .filter(
            (process) => processAssignments[process.batchKey] === "TARGET_USER"
          )
          .map((process) => process.processGuid)
      )
    ),
    userIds: [...config.userIds],
  });
  profiles.value = profileResponse.data.data || [];
  if (profiles.value.length !== config.userIds.length) {
    throw new Error(t("documentBatch.profileMismatch"));
  }

  const details = await Promise.all(
    selectedTemplateIds.value.map((id) => DocumentTemplateDataService.get(id))
  );
  const detailedTemplates = details.map(
    (response) => response.data.data as BatchTemplate
  );
  const detailedTemplatesById = new Map(
    detailedTemplates.map((template) => [String(template.id), template])
  );
  templates.value = templates.value.map(
    (template) => detailedTemplatesById.get(String(template.id)) || template
  );

  logicalFields.value = createLogicalFields(detailedTemplates);
  logicalFields.value.forEach((field) => {
    fieldScopes[field.key] = field.scope;
    if (!(field.key in commonValues)) {
      commonValues[field.key] = field.type === "MULTI_SELECT" ? [] : "";
    }
  });
  profiles.value.forEach((profile) => {
    const defaults = buildProfileValues(profile);
    const values = individualValues[profile.id] || {};
    logicalFields.value.forEach((field) => {
      if (!(field.key in values)) {
        values[field.key] =
          defaults[field.key as keyof typeof defaults] ??
          (field.type === "MULTI_SELECT" ? [] : "");
      }
    });
    individualValues[profile.id] = values;
  });
  if (
    previewProfileId.value == null ||
    !profiles.value.some((profile) => profile.id === previewProfileId.value)
  ) {
    previewProfileId.value = profiles.value[0]?.id || null;
  }
  detailedTemplates.forEach((template) => {
    if (!titlePatterns[template.id]) {
      titlePatterns[template.id] = "{{template_name}}_{{full_name}}";
    }
  });
}

function validateAllFields() {
  for (const field of commonFields.value) {
    if (field.required && isEmptyBatchValue(commonValues[field.key])) {
      return `${t("documentBatch.fillField")}: ${field.label}`;
    }
  }
  for (const profile of profiles.value) {
    const values = individualValues[profile.id];
    const resolvedValues = effectiveValues(values);
    for (const field of individualFields.value) {
      if (field.required && isEmptyBatchValue(values[field.key])) {
        return `${profile.fullName}: ${t("documentBatch.fillField")} «${
          field.label
        }»`;
      }
    }
    const chronologyError = validateChronology(resolvedValues);
    if (chronologyError) return `${profile.fullName}: ${chronologyError}`;
    for (const template of selectedTemplates.value) {
      const invalid = validateTemplateValues(
        template,
        commonValues,
        values,
        fieldScopes
      );
      if (invalid.length) {
        return `${profile.fullName}, ${template.name}: ${t(
          "documentBatch.invalidFields"
        )} ${invalid.join(", ")}`;
      }
      const unresolvedTags = findUnresolvedTemplateTags(
        template,
        buildTemplateFieldConfig(template, commonValues, values, fieldScopes)
      );
      if (unresolvedTags.length) {
        return `${profile.fullName}, ${template.name}: ${t(
          "documentBatch.unresolvedTags"
        )} ${unresolvedTags.join(", ")}`;
      }
      const title = resolveDocumentTitle(
        titlePatterns[template.id],
        template.name,
        resolvedValues
      );
      if (!title || /\{\{[^}]+\}\}/.test(title)) {
        return `${template.name}: ${t("documentBatch.invalidTitle")}`;
      }
      if (title.length > 500) {
        return `${template.name}: ${t("documentBatch.titleTooLong")}`;
      }
    }
  }
  return "";
}

function selectedPreviewProfile() {
  return profiles.value.find(
    (profile) => profile.id === previewProfileId.value
  );
}

function previewDocumentName(template: BatchTemplate) {
  const profile = selectedPreviewProfile();
  if (!profile) return template.name;
  return resolveDocumentTitle(
    titlePatterns[template.id] || "{{template_name}}_{{full_name}}",
    template.name,
    effectiveValues(individualValues[profile.id] || {})
  );
}

function escapePreviewValue(value: string) {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function buildTemplatePreviewContent(
  template: BatchTemplate,
  profile: DocumentBatchUserProfile
) {
  let content = template.template || "";
  const fieldConfig = buildTemplateFieldConfig(
    template,
    commonValues,
    individualValues[profile.id] || {},
    fieldScopes
  );
  fieldConfig.forEach((field) => {
    const value = escapePreviewValue(
      formatTemplateFieldValue(field.value, field.type, field.outputFormat)
    );
    content = content.split(field.key).join(value);
    if (!field.key.startsWith("key_")) {
      content = content.split(`key_${field.key}`).join(value);
    }
  });

  return content;
}

function previewDraftKey(profileId: string, templateId: string) {
  return `u${profileId}-t${templateId}`;
}

function buildPreviewFieldSnapshot(
  template: BatchTemplate,
  profile: DocumentBatchUserProfile
) {
  const fields = buildTemplateFieldConfig(
    template,
    commonValues,
    individualValues[profile.id] || {},
    fieldScopes
  ).map((field) => [
    field.key,
    field.type,
    field.outputFormat || null,
    field.value,
    field.values || null,
  ]);
  return JSON.stringify({ templateId: String(template.id), fields });
}

function hasManualPreviewEdits(draft: BatchPreviewDraft) {
  return draft.manuallyEdited && draft.html !== draft.generatedHtml;
}

function rebuildPreviewDraft(
  draft: BatchPreviewDraft,
  template: BatchTemplate,
  profile: DocumentBatchUserProfile
) {
  const html = buildTemplatePreviewContent(template, profile);
  draft.html = html;
  draft.generatedHtml = html;
  draft.fieldSnapshot = buildPreviewFieldSnapshot(template, profile);
  draft.manuallyEdited = false;
}

function requestPreviewConflictChoice() {
  showPreviewConflictModal.value = true;
  return new Promise<PreviewConflictChoice>((resolve) => {
    previewConflictResolve = resolve;
  });
}

function resolvePreviewConflict(choice: PreviewConflictChoice) {
  showPreviewConflictModal.value = false;
  if (previewConflictResolve) {
    previewConflictResolve(choice);
    previewConflictResolve = null;
  }
}

async function resolvePreviewDraftConflict(
  draft: BatchPreviewDraft,
  template: BatchTemplate,
  profile: DocumentBatchUserProfile
) {
  const currentSnapshot = buildPreviewFieldSnapshot(template, profile);
  if (
    !hasManualPreviewEdits(draft) ||
    draft.fieldSnapshot === currentSnapshot
  ) {
    return true;
  }

  const choice = await requestPreviewConflictChoice();
  if (choice === null) return false;
  if (choice === "REBUILD") {
    rebuildPreviewDraft(draft, template, profile);
  } else {
    draft.fieldSnapshot = currentSnapshot;
  }
  return true;
}

async function resolveStalePreviewDrafts() {
  const profilesById = new Map(
    profiles.value.map((profile) => [profile.id, profile])
  );
  const templatesById = new Map(
    selectedTemplates.value.map((template) => [String(template.id), template])
  );
  const staleDrafts: Array<{
    draft: BatchPreviewDraft;
    profile: DocumentBatchUserProfile;
    template: BatchTemplate;
  }> = [];

  previewDrafts.forEach((draft, key) => {
    const profile = profilesById.get(draft.profileId);
    const template = templatesById.get(draft.templateId);
    if (!profile || !template) {
      previewDrafts.delete(key);
      return;
    }
    if (
      hasManualPreviewEdits(draft) &&
      draft.fieldSnapshot !== buildPreviewFieldSnapshot(template, profile)
    ) {
      staleDrafts.push({ draft, profile, template });
    }
  });

  if (!staleDrafts.length) return true;
  const choice = await requestPreviewConflictChoice();
  if (choice === null) return false;
  staleDrafts.forEach(({ draft, profile, template }) => {
    if (choice === "REBUILD") {
      rebuildPreviewDraft(draft, template, profile);
    } else {
      draft.fieldSnapshot = buildPreviewFieldSnapshot(template, profile);
    }
  });
  return true;
}

async function openTemplatePreview(template: BatchTemplate) {
  pageError.value = "";
  const profile = selectedPreviewProfile();
  if (!profile) {
    pageError.value = t("documentBatch.previewEmployeeRequired");
    return;
  }
  const values = individualValues[profile.id] || {};
  const invalidFields = validateTemplateValues(
    template,
    commonValues,
    values,
    fieldScopes
  );
  if (invalidFields.length) {
    pageError.value = `${profile.fullName}, ${template.name}: ${t(
      "documentBatch.invalidFields"
    )} ${invalidFields.join(", ")}`;
    return;
  }
  const unresolvedTags = findUnresolvedTemplateTags(
    template,
    buildTemplateFieldConfig(template, commonValues, values, fieldScopes)
  );
  if (unresolvedTags.length) {
    pageError.value = `${profile.fullName}, ${template.name}: ${t(
      "documentBatch.unresolvedTags"
    )} ${unresolvedTags.join(", ")}`;
    return;
  }

  const key = previewDraftKey(profile.id, template.id);
  let draft = previewDrafts.get(key);
  if (!draft) {
    const html = buildTemplatePreviewContent(template, profile);
    draft = {
      profileId: profile.id,
      templateId: String(template.id),
      html,
      generatedHtml: html,
      fieldSnapshot: buildPreviewFieldSnapshot(template, profile),
      manuallyEdited: false,
    };
    previewDrafts.set(key, draft);
  } else if (!hasManualPreviewEdits(draft)) {
    rebuildPreviewDraft(draft, template, profile);
  } else if (!(await resolvePreviewDraftConflict(draft, template, profile))) {
    return;
  }

  activePreviewKey.value = key;
  previewDocumentTitle.value = previewDocumentName(template);
  previewTemplateName.value = template.name;
  previewEmployeeName.value = profile.fullName;
  previewHtml.value = draft.html;
  previewModalIsOpen.value = true;
}

function saveActivePreviewDraft() {
  if (!activePreviewKey.value) return;
  const draft = previewDrafts.get(activePreviewKey.value);
  if (draft) draft.html = previewHtml.value;
}

function markActivePreviewAsEdited() {
  saveActivePreviewDraft();
  const draft = previewDrafts.get(activePreviewKey.value);
  if (draft) draft.manuallyEdited = true;
}

function closeTemplatePreview() {
  saveActivePreviewDraft();
  previewModalIsOpen.value = false;
  previewHtml.value = "";
  activePreviewKey.value = "";
  previewDocumentTitle.value = "";
  previewTemplateName.value = "";
  previewEmployeeName.value = "";
}

function resetTemplatePreviewState() {
  closeTemplatePreview();
  resolvePreviewConflict(null);
  previewDrafts.clear();
}

function validateChronology(values: BatchFieldValues) {
  const probationStart = String(values.probation_start_date || "");
  const probationEnd = String(values.probation_end_date || "");
  if (probationStart && probationEnd && probationStart > probationEnd) {
    return t("documentBatch.probationDatesInvalid");
  }
  const workStart = String(values.work_start_date || "");
  const contractEnd = String(values.contract_end_date || "");
  if (workStart && contractEnd && workStart > contractEnd) {
    return t("documentBatch.contractDatesInvalid");
  }
  return "";
}

async function createBatch() {
  const validation = validateAllFields();
  if (validation) {
    pageError.value = validation;
    step.value = 2;
    return;
  }
  if (!(await resolveStalePreviewDrafts())) {
    step.value = 2;
    return;
  }
  pageError.value = "";
  isCreating.value = true;
  try {
    const response = await DocumentBatchDataService.start({
      name: config.name,
      idempotencyKey: batchKey,
      expectedItems: totalDocuments.value,
    });
    batchId.value = response.data.data.id;
    results.value = createCreationTasks();
    await runPool(results.value, 3);
  } catch (error) {
    pageError.value = extractError(error, t("documentBatch.startError"));
  } finally {
    isCreating.value = false;
  }
}

function createCreationTasks(): CreationTaskResult[] {
  if (isPackageMode.value) {
    const mainTemplate = selectedMainTemplate.value;
    const mainUpload =
      mainSourceMode.value === "UPLOAD" ? uploadedMainFile.value : null;
    if (!mainTemplate && !mainUpload) return [];
    return profiles.value.map((profile) => ({
      itemKey: mainTemplate
        ? `u${profile.id}-p${mainTemplate.id}`
        : `u${profile.id}-f${mainUpload!.key}`,
      userId: profile.id,
      userName: profile.fullName,
      templateId: mainTemplate?.id ?? null,
      templateIds: selectedTemplates.value.map((template) => template.id),
      templateName: mainTemplate?.name ?? mainUpload!.name,
      uploadedMainKey: mainUpload?.key ?? null,
      uploadedAdditionalKeys:
        additionalSourceMode.value === "UPLOAD"
          ? uploadedAdditionalFiles.value.map((file) => file.key)
          : [],
      status: "PENDING" as const,
      error: "",
      fileGuids: {},
    }));
  }
  if (standaloneSourceMode.value === "UPLOAD") {
    return profiles.value.flatMap((profile) =>
      uploadedStandaloneFiles.value.map((file) => ({
        itemKey: `u${profile.id}-f${file.key}`,
        userId: profile.id,
        userName: profile.fullName,
        templateId: null,
        templateIds: [],
        templateName: file.name,
        uploadedMainKey: file.key,
        uploadedAdditionalKeys: [],
        status: "PENDING" as const,
        error: "",
        fileGuids: {},
      }))
    );
  }
  return profiles.value.flatMap((profile) =>
    selectedTemplates.value.map((template) => ({
      itemKey: `u${profile.id}-t${template.id}`,
      userId: profile.id,
      userName: profile.fullName,
      templateId: template.id,
      templateIds: [template.id],
      templateName: template.name,
      uploadedMainKey: null,
      uploadedAdditionalKeys: [],
      status: "PENDING" as const,
      error: "",
      fileGuids: {},
    }))
  );
}

async function retryFailed() {
  failedResults.value.forEach((result) => {
    result.status = "PENDING";
    result.error = "";
  });
  isCreating.value = true;
  try {
    await runPool(
      results.value.filter((result) => result.status === "PENDING"),
      3
    );
  } finally {
    isCreating.value = false;
  }
}

async function runPool(tasks: CreationTaskResult[], concurrency: number) {
  let cursor = 0;
  const workers = Array.from(
    { length: Math.min(concurrency, tasks.length) },
    async () => {
      while (cursor < tasks.length) {
        const index = cursor++;
        await runTask(tasks[index]);
      }
    }
  );
  await Promise.all(workers);
}

async function runTask(task: CreationTaskResult) {
  const profile = profiles.value.find((item) => item.id === task.userId);
  const taskTemplates = task.templateIds
    .map((templateId) =>
      selectedTemplates.value.find(
        (template) => String(template.id) === String(templateId)
      )
    )
    .filter((template): template is BatchTemplate => Boolean(template));
  const mainTemplate =
    task.templateId == null
      ? null
      : taskTemplates.find(
          (template) => String(template.id) === String(task.templateId)
        ) || null;
  const uploadedMain = task.uploadedMainKey
    ? findUploadedFile(task.uploadedMainKey)
    : null;
  const uploadedAdditional = task.uploadedAdditionalKeys
    .map(findUploadedFile)
    .filter((file): file is BatchUploadedFile => Boolean(file));
  if (
    !profile ||
    (!mainTemplate && !uploadedMain) ||
    taskTemplates.length !== task.templateIds.length ||
    uploadedAdditional.length !== task.uploadedAdditionalKeys.length ||
    batchId.value == null
  ) {
    task.status = "FAILED";
    task.error = t("documentBatch.itemError");
    return;
  }
  const values = individualValues[profile.id];
  try {
    const documentFiles: DocumentCreate["documentFiles"] = [];
    if (uploadedMain) {
      documentFiles.push({
        fileGuid: await uploadBatchFile(uploadedMain),
        type: "MAIN",
      });
    }
    for (const template of taskTemplates) {
      let fileGuid = task.fileGuids[template.id];
      if (!fileGuid) {
        const title = resolveDocumentTitle(
          titlePatterns[template.id],
          template.name,
          effectiveValues(values)
        );
        const previewDraft = previewDrafts.get(
          previewDraftKey(profile.id, template.id)
        );
        const manualPreviewHtml =
          previewDraft != null && hasManualPreviewEdits(previewDraft)
            ? previewDraft.html
            : null;
        const fieldConfig = buildTemplateFieldConfig(
          template,
          commonValues,
          values,
          fieldScopes
        );
        const conversion = await DocumentTemplateDataService.convert({
          name: safeFileName(title),
          templateId: template.id,
          template: `<div style="font-family: 'times new roman', times, serif;">${
            manualPreviewHtml ?? template.template
          }</div>`,
          fieldConfig: manualPreviewHtml !== null ? [] : fieldConfig,
        });
        fileGuid = conversion.data.data.fileGuid;
        task.fileGuids[template.id] = fileGuid;
      }
      documentFiles.push({
        fileGuid,
        type:
          mainTemplate && String(template.id) === String(mainTemplate.id)
            ? "MAIN"
            : "SUB",
        editableSource: {
          templateId: String(template.id),
          templateName: template.name,
          fileName: safeFileName(
            resolveDocumentTitle(
              titlePatterns[template.id],
              template.name,
              effectiveValues(values)
            )
          ),
          templateHtml: template.template,
          editorHtml:
            previewDrafts.get(previewDraftKey(profile.id, template.id))?.html ??
            buildTemplatePreviewContent(template, profile),
          manualFields: template.manualFields ?? [],
          fieldValues: buildTemplateFieldConfig(
                template,
                commonValues,
                values,
                fieldScopes
          ).reduce((result, field) => {
            result[field.key] = field.values ?? field.value;
            return result;
          }, {} as Record<string, unknown>),
        },
        });
      }
    for (const file of uploadedAdditional) {
      documentFiles.push({
        fileGuid: await uploadBatchFile(file),
        type: "SUB",
      });
    }
    const request: DocumentBatchItemRequest = {
      itemKey: task.itemKey,
      recipientUserId: profile.id,
      templateId: mainTemplate?.id ?? null,
      sendForExecution: config.sendForExecution,
      document: buildDocument(
        mainTemplate,
        uploadedMain?.name ?? task.templateName,
        profile,
        documentFiles
      ),
    };
    await DocumentBatchDataService.createItem(batchId.value, request);
    task.status = "SUCCESS";
  } catch (error) {
    task.status = "FAILED";
    task.error = extractError(error, t("documentBatch.itemError"));
    if (batchId.value != null) {
      try {
        await DocumentBatchDataService.recordPreparationFailure(batchId.value, {
          itemKey: task.itemKey,
          recipientUserId: task.userId,
          templateId: task.templateId,
          sendForExecution: config.sendForExecution,
        });
      } catch (_) {
        // The original error is more useful to the user; status reporting is best effort.
      }
    }
  }
}

function buildDocument(
  template: BatchTemplate | null,
  sourceName: string,
  profile: DocumentBatchUserProfile,
  documentFiles: DocumentCreate["documentFiles"]
): DocumentCreate {
  const values = individualValues[profile.id];
  const params = constructorInfo.value?.params;
  const esedo = params?.esedoConfig;
  return {
    constructorId: config.constructorId,
    linkedDocId: null,
    documentInfo: {
      title: template
        ? resolveDocumentTitle(
        titlePatterns[template.id],
        template.name,
        effectiveValues(values)
          )
        : uploadedDocumentTitle(sourceName, profile.fullName),
      nomenclature: config.nomenclatureId,
      description: config.description,
      price: config.price,
      esedoDocumentTypeId: esedo?.enabled ? esedo.documentTypeId || null : null,
      esedoQuestionNatureId: esedo?.enabled
        ? esedo.questionNatureId || null
        : null,
      counterpartyIds: [],
    },
    documentFiles,
    documentProcessesInfo: {
      isQueue: false,
      deadline: config.deadline,
      processList: configuredProcesses.value.map((process, index) => ({
        constructorProcessGuid: process.processGuid,
        position: index + 1,
        templateId: process.templateId,
        isQueue: process.isFreeInstance
          ? freeProcessQueueModes[process.batchKey]
          : !(process.allowParallel ?? false),
        comment: "",
        users:
          processAssignments[process.batchKey] === "TARGET_USER"
            ? [profile.id]
            : [],
        usersFilter: null,
        usersFilterInit: null,
        usersPager: {
          buttonsToShow: 3,
          currentPage: 1,
          endPage: 1,
          startPage: 1,
          totalPages: 1,
        },
        usersInfo: [],
        name: process.templateName || null,
        type: null,
      })),
    },
  };
}

function findUploadedFile(key: string) {
  if (uploadedMainFile.value?.key === key) return uploadedMainFile.value;
  return [
    ...uploadedStandaloneFiles.value,
    ...uploadedAdditionalFiles.value,
  ].find((file) => file.key === key);
}

async function uploadBatchFile(file: BatchUploadedFile) {
  const form = new FormData();
  form.append("file", file.source);
  const response = await DocumentDataService.uploadDocument(form);
  const fileGuid = response.data?.data?.fileGuid;
  if (!fileGuid) throw new Error(t("documentBatch.fileUploadError"));
  return String(fileGuid);
}

function uploadedDocumentTitle(fileName: string, fullName: string) {
  const extensionIndex = fileName.lastIndexOf(".");
  const baseName =
    extensionIndex > 0 ? fileName.slice(0, extensionIndex) : fileName;
  return `${baseName}_${fullName}`.slice(0, 500);
}

function effectiveValues(individual: BatchFieldValues): BatchFieldValues {
  const effective = { ...individual };
  logicalFields.value.forEach((field) => {
    if (fieldScopes[field.key] === "COMMON") {
      effective[field.key] = commonValues[field.key];
    }
  });
  return effective;
}

function safeFileName(value: string) {
  const withoutControlCharacters = value
    .split("")
    .map((character) => (character.charCodeAt(0) < 32 ? "_" : character))
    .join("");
  return (
    withoutControlCharacters.replace(/[<>:"/\\|?*]/g, "_").slice(0, 180) ||
    "document"
  );
}

function createUuid() {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
    const random = (Math.random() * 16) | 0;
    const value = char === "x" ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}

function extractError(error: unknown, fallback: string) {
  const candidate = error as {
    response?: { data?: unknown };
    data?: unknown;
    message?: string;
  };
  const response = (candidate?.response?.data || candidate?.data) as
    | { data?: unknown; message?: string }
    | undefined;
  const validation = response?.data;
  if (
    validation &&
    typeof validation === "object" &&
    !Array.isArray(validation)
  ) {
    const first = Object.values(validation).find(
      (value) => typeof value === "string"
    );
    if (first) return String(first);
  }
  return response?.message || candidate?.message || fallback;
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)("documentBatch.title")), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("documentBatch.subtitle")), 1)
      ]),
      _createVNode(_component_Button, {
        variant: "default",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'DocumentList' })))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.back")), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("ol", _hoisted_5, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item) => {
        return _createElementVNode("li", {
          key: item,
          class: _normalizeClass({ active: step.value === item, done: step.value > item })
        }, [
          _createElementVNode("span", null, _toDisplayString(item), 1),
          _createTextVNode(" " + _toDisplayString(_unref(t)(`documentBatch.step${item}`)), 1)
        ], 2)
      }), 64))
    ]),
    (pageError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(pageError.value), 1))
      : _createCommentVNode("", true),
    (step.value === 1)
      ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)("documentBatch.name")) + " *", 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(config).name) = $event)),
                type: "text",
                maxlength: "200"
              }, null, 512), [
                [
                  _vModelText,
                  _unref(config).name,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("label", _hoisted_10, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)("documentBatch.deadline")) + " *", 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(config).deadline) = $event)),
                type: "date",
                min: today
              }, null, 512), [
                [_vModelText, _unref(config).deadline]
              ])
            ]),
            _createElementVNode("label", _hoisted_11, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)("documentBatch.category")) + " *", 1),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(config).constructorId) = $event)),
                onChange: onConstructorChange
              }, [
                _hoisted_12,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(constructors.value, (item) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: item.id,
                    value: item.id
                  }, _toDisplayString(item.name), 9, _hoisted_13))
                }), 128))
              ], 544), [
                [_vModelSelect, _unref(config).constructorId]
              ])
            ]),
            _createElementVNode("label", _hoisted_14, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)("documentBatch.nomenclature")) + " *", 1),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(config).nomenclatureId) = $event)),
                onChange: resetUnavailableTemplates
              }, [
                _hoisted_15,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nomenclatures.value, (item) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: item.id,
                    value: item.id
                  }, _toDisplayString(nomenclatureOptionLabel(item)), 9, _hoisted_16))
                }), 128))
              ], 544), [
                [_vModelSelect, _unref(config).nomenclatureId]
              ])
            ]),
            (constructorInfo.value?.params?.description?.isSelected)
              ? (_openBlock(), _createElementBlock("label", _hoisted_17, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("documentBatch.description")), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(config).description) = $event)),
                    rows: "2",
                    maxlength: "1000"
                  }, null, 512), [
                    [
                      _vModelText,
                      _unref(config).description,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]))
              : _createCommentVNode("", true),
            (constructorInfo.value?.params?.price?.isSelected)
              ? (_openBlock(), _createElementBlock("label", _hoisted_18, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("documentBatch.price")), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(config).price) = $event)),
                    type: "text",
                    maxlength: "100"
                  }, null, 512), [
                    [
                      _vModelText,
                      _unref(config).price,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (constructorInfo.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("h2", null, _toDisplayString(_unref(t)("documentBatch.processes")), 1),
                _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(t)("documentBatch.processHint")), 1),
                (_unref(freeProcessOptions).length)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_21, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)("documentBatch.freeProcesses")), 1),
                      _createVNode(_unref(Multiselect), {
                        modelValue: selectedFreeProcessKeys.value,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedFreeProcessKeys).value = $event)),
                        mode: "tags",
                        options: _unref(freeProcessOptions),
                        "value-prop": "value",
                        "track-by": "label",
                        label: "label",
                        searchable: true,
                        "close-on-select": false,
                        placeholder: _unref(t)('documentBatch.selectFreeProcesses'),
                        onChange: onFreeProcessesChange
                      }, null, 8, ["modelValue", "options", "placeholder"]),
                      _createElementVNode("small", null, _toDisplayString(_unref(t)("documentBatch.freeProcessesHint")), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(configuredProcesses).length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(configuredProcesses), (process) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: process.batchKey,
                          class: _normalizeClass(["batch-process", { 'batch-process--free': process.isFreeInstance }])
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("strong", null, _toDisplayString(process.templateName || _unref(t)("docForm.process")), 1),
                            (process.isRequired)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_23, _toDisplayString(_unref(t)("documentBatch.requiredProcess")), 1))
                              : _createCommentVNode("", true)
                          ]),
                          (process.isFreeInstance)
                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 0,
                                "onUpdate:modelValue": ($event: any) => ((_unref(freeProcessQueueModes)[process.batchKey]) = $event),
                                "aria-label": _unref(t)('docForm.executionType')
                              }, [
                                _createElementVNode("option", _hoisted_25, _toDisplayString(_unref(t)("docForm.serialExecution")), 1),
                                _createElementVNode("option", _hoisted_26, _toDisplayString(_unref(t)("docForm.parallelExecution")), 1)
                              ], 8, _hoisted_24)), [
                                [_vModelSelect, _unref(freeProcessQueueModes)[process.batchKey]]
                              ])
                            : _createCommentVNode("", true),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": ($event: any) => ((_unref(processAssignments)[process.batchKey]) = $event),
                            onChange: onProcessAssignmentChange
                          }, [
                            _createElementVNode("option", _hoisted_28, _toDisplayString(_unref(t)("documentBatch.selectedEmployee")), 1),
                            (hasDefaultExecutors(process))
                              ? (_openBlock(), _createElementBlock("option", _hoisted_29, _toDisplayString(_unref(t)("documentBatch.categoryExecutors")), 1))
                              : _createCommentVNode("", true)
                          ], 40, _hoisted_27), [
                            [_vModelSelect, _unref(processAssignments)[process.batchKey]]
                          ])
                        ], 2))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_unref(t)("documentBatch.noProcesses")), 1))
              ]))
            : _createCommentVNode("", true),
          (!_unref(isPackageMode))
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("h2", null, _toDisplayString(_unref(t)("documentBatch.documentSource")), 1),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass({ active: standaloneSourceMode.value === 'TEMPLATE' }),
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (standaloneSourceMode.value = 'TEMPLATE'))
                  }, _toDisplayString(_unref(t)("docForm.generateTab")), 3),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass({ active: standaloneSourceMode.value === 'UPLOAD' }),
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (standaloneSourceMode.value = 'UPLOAD'))
                  }, _toDisplayString(_unref(t)("docForm.uploadTab")), 3)
                ]),
                (standaloneSourceMode.value === 'TEMPLATE')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_33, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)("documentBatch.templates")) + " *", 1),
                      _createVNode(_unref(Multiselect), {
                        modelValue: _unref(config).templateIds,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(config).templateIds) = $event)),
                        mode: "tags",
                        options: _unref(availableTemplates),
                        "value-prop": "id",
                        "track-by": "name",
                        label: "name",
                        searchable: true,
                        "close-on-select": false,
                        placeholder: _unref(t)('documentBatch.selectTemplates')
                      }, null, 8, ["modelValue", "options", "placeholder"]),
                      _createElementVNode("small", null, _toDisplayString(_unref(t)("documentBatch.templatesSelected").replace(
              "{count}",
              String(_unref(config).templateIds.length)
            )), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createVNode(DocumentUploadZone, {
                        multiple: "",
                        onFilesSelected: _cache[11] || (_cache[11] = ($event: any) => (addSelectedFiles($event, 'STANDALONE')))
                      }),
                      (uploadedStandaloneFiles.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uploadedStandaloneFiles.value, (file) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: file.key
                              }, [
                                _createElementVNode("span", null, [
                                  _createElementVNode("strong", null, _toDisplayString(file.name), 1),
                                  _createElementVNode("small", null, _toDisplayString(formatFileSize(file.size)), 1)
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: ($event: any) => (removeUploadedFile('STANDALONE', file.key))
                                }, _toDisplayString(_unref(t)("common.delete")), 9, _hoisted_36)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("h2", null, _toDisplayString(_unref(t)("documentBatch.mainFile")) + " *", 1),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass({ active: mainSourceMode.value === 'TEMPLATE' }),
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (mainSourceMode.value = 'TEMPLATE'))
                    }, _toDisplayString(_unref(t)("docForm.generateTab")), 3),
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass({ active: mainSourceMode.value === 'UPLOAD' }),
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (mainSourceMode.value = 'UPLOAD'))
                    }, _toDisplayString(_unref(t)("docForm.uploadTab")), 3)
                  ]),
                  (mainSourceMode.value === 'TEMPLATE')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_40, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)("documentBatch.mainTemplate")), 1),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(config).mainTemplateId) = $event)),
                          onChange: onMainTemplateChange
                        }, [
                          _createElementVNode("option", _hoisted_41, _toDisplayString(_unref(t)("documentBatch.selectMainTemplate")), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableTemplates), (template) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: template.id,
                              value: template.id
                            }, _toDisplayString(template.name), 9, _hoisted_42))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, _unref(config).mainTemplateId]
                        ]),
                        _createElementVNode("small", null, _toDisplayString(_unref(t)("documentBatch.mainTemplateHint")), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _createVNode(DocumentUploadZone, {
                          onFilesSelected: _cache[15] || (_cache[15] = ($event: any) => (addSelectedFiles($event, 'MAIN')))
                        }),
                        (uploadedMainFile.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", null, [
                                  _createElementVNode("strong", null, _toDisplayString(uploadedMainFile.value.name), 1),
                                  _createElementVNode("small", null, _toDisplayString(formatFileSize(uploadedMainFile.value.size)), 1)
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: _cache[16] || (_cache[16] = ($event: any) => (removeUploadedFile('MAIN', uploadedMainFile.value.key)))
                                }, _toDisplayString(_unref(t)("common.delete")), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("h2", null, _toDisplayString(_unref(t)("documentBatch.additionalFiles")) + " *", 1),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass({ active: additionalSourceMode.value === 'TEMPLATE' }),
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (additionalSourceMode.value = 'TEMPLATE'))
                    }, _toDisplayString(_unref(t)("docForm.generateTab")), 3),
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass({ active: additionalSourceMode.value === 'UPLOAD' }),
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (additionalSourceMode.value = 'UPLOAD'))
                    }, _toDisplayString(_unref(t)("docForm.uploadTab")), 3)
                  ]),
                  (additionalSourceMode.value === 'TEMPLATE')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_47, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)("documentBatch.additionalTemplates")), 1),
                        _createVNode(_unref(Multiselect), {
                          modelValue: _unref(config).additionalTemplateIds,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(config).additionalTemplateIds) = $event)),
                          mode: "tags",
                          options: _unref(availableAdditionalTemplates),
                          "value-prop": "id",
                          "track-by": "name",
                          label: "name",
                          searchable: true,
                          "close-on-select": false,
                          placeholder: _unref(t)('documentBatch.selectAdditionalTemplates')
                        }, null, 8, ["modelValue", "options", "placeholder"]),
                        _createElementVNode("small", null, _toDisplayString(_unref(t)("documentBatch.additionalTemplatesSelected").replace(
                "{count}",
                String(_unref(config).additionalTemplateIds.length)
              )), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        _createVNode(DocumentUploadZone, {
                          multiple: "",
                          onFilesSelected: _cache[20] || (_cache[20] = ($event: any) => (addSelectedFiles($event, 'ADDITIONAL')))
                        }),
                        (uploadedAdditionalFiles.value.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uploadedAdditionalFiles.value, (file) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: file.key
                                }, [
                                  _createElementVNode("span", null, [
                                    _createElementVNode("strong", null, _toDisplayString(file.name), 1),
                                    _createElementVNode("small", null, _toDisplayString(formatFileSize(file.size)), 1)
                                  ]),
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: ($event: any) => (removeUploadedFile('ADDITIONAL', file.key))
                                  }, _toDisplayString(_unref(t)("common.delete")), 9, _hoisted_50)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                ])
              ])),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("label", _hoisted_52, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)("documentBatch.employees")) + " *", 1),
              _createVNode(_unref(Multiselect), {
                ref: (_value, _refs) => {
                  _refs['usersMultiselect'] = _value
                  usersMultiselect.value = _value
                },
                modelValue: _unref(config).userIds,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(config).userIds) = $event)),
                mode: "tags",
                options: userOptions.value,
                "value-prop": "id",
                "track-by": "fullName",
                label: "fullName",
                searchable: true,
                "close-on-select": false,
                disabled: !_unref(targetProcess),
                loading: isUsersLoading.value,
                placeholder: _unref(t)('documentBatch.selectEmployees'),
                onOpen: onUsersOpen,
                onClose: detachUsersScrollListener,
                onSearchChange: onUserSearchChange
              }, null, 8, ["modelValue", "options", "disabled", "loading", "placeholder"]),
              _createElementVNode("small", null, _toDisplayString(_unref(t)("documentBatch.employeesSelected").replace(
              "{count}",
              String(_unref(config).userIds.length)
            )), 1)
            ])
          ]),
          (_unref(isPackageMode))
            ? (_openBlock(), _createElementBlock("p", _hoisted_53, _toDisplayString(_unref(t)("documentBatch.packageModeHint")), 1))
            : _createCommentVNode("", true),
          _createElementVNode("label", _hoisted_54, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(config).sendForExecution) = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, _unref(config).sendForExecution]
            ]),
            _createElementVNode("span", null, [
              _createElementVNode("strong", null, _toDisplayString(_unref(t)("documentBatch.sendImmediately")), 1),
              _createElementVNode("small", null, _toDisplayString(_unref(t)("documentBatch.sendImmediatelyHint")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_55, [
            _createTextVNode(_toDisplayString(_unref(t)("documentBatch.totalDocuments")) + ": ", 1),
            _createElementVNode("strong", null, _toDisplayString(_unref(totalDocuments)), 1),
            (_unref(isPackageMode))
              ? (_openBlock(), _createElementBlock("span", _hoisted_56, [
                  _createTextVNode(" · " + _toDisplayString(_unref(t)("documentBatch.totalFiles")) + ": ", 1),
                  _createElementVNode("strong", null, _toDisplayString(_unref(totalFiles)), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : (step.value === 2)
        ? (_openBlock(), _createElementBlock("section", _hoisted_57, [
            (logicalFields.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h2", null, _toDisplayString(_unref(t)("documentBatch.fieldScopes")), 1),
                      _createElementVNode("p", _hoisted_60, _toDisplayString(_unref(t)("documentBatch.fieldScopesHint")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logicalFields.value, (field) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: field.key,
                        class: "batch-scope-row"
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("strong", null, _toDisplayString(field.label), 1),
                          _createElementVNode("small", null, _toDisplayString(field.templateNames.join(", ")), 1)
                        ]),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => ((_unref(fieldScopes)[field.key]) = $event)
                        }, [
                          _createElementVNode("option", _hoisted_63, _toDisplayString(_unref(t)("documentBatch.commonValue")), 1),
                          _createElementVNode("option", _hoisted_64, _toDisplayString(_unref(t)("documentBatch.individualValue")), 1)
                        ], 8, _hoisted_62), [
                          [_vModelSelect, _unref(fieldScopes)[field.key]]
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(commonFields).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                  _createElementVNode("h2", null, _toDisplayString(_unref(t)("documentBatch.commonFields")), 1),
                  _createElementVNode("div", _hoisted_66, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(commonFields), (field) => {
                      return (_openBlock(), _createBlock(_unref(BatchFieldInput), {
                        key: field.key,
                        modelValue: _unref(commonValues)[field.key],
                        "onUpdate:modelValue": ($event: any) => ((_unref(commonValues)[field.key]) = $event),
                        field: field
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "field"]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(individualFields).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                  _createElementVNode("h2", null, _toDisplayString(_unref(t)("documentBatch.individualFields")), 1),
                  _createElementVNode("p", _hoisted_68, _toDisplayString(_unref(t)("documentBatch.profileHint")), 1),
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("table", _hoisted_70, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_71, _toDisplayString(_unref(t)("documentBatch.employee")), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(individualFields), (field) => {
                            return (_openBlock(), _createElementBlock("th", {
                              key: field.key
                            }, [
                              _createTextVNode(_toDisplayString(field.label), 1),
                              (field.required)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_72, " *"))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profiles.value, (profile) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: profile.id
                          }, [
                            _createElementVNode("th", _hoisted_73, _toDisplayString(profile.fullName), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(individualFields), (field) => {
                              return (_openBlock(), _createElementBlock("td", {
                                key: field.key
                              }, [
                                _createVNode(_unref(BatchFieldInput), {
                                  modelValue: _unref(individualValues)[profile.id][field.key],
                                  "onUpdate:modelValue": ($event: any) => ((_unref(individualValues)[profile.id][field.key]) = $event),
                                  field: field,
                                  compact: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "field"])
                              ]))
                            }), 128))
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(selectedTemplates).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                  _createElementVNode("h2", null, _toDisplayString(_unref(isPackageMode)
              ? _unref(t)("documentBatch.fileNames")
              : _unref(t)("documentBatch.documentNames")), 1),
                  _createElementVNode("p", _hoisted_75, _toDisplayString(_unref(isPackageMode)
              ? _unref(t)("documentBatch.fileNamesHint")
              : _unref(t)("documentBatch.documentNamesHint")), 1),
                  _createElementVNode("div", _hoisted_76, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedTemplates), (template) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: template.id,
                        class: "batch-field"
                      }, [
                        _createElementVNode("span", _hoisted_77, [
                          _createTextVNode(_toDisplayString(template.name) + " * ", 1),
                          (_unref(isPackageMode))
                            ? (_openBlock(), _createElementBlock("small", _hoisted_78, _toDisplayString(templateRoleLabel(template)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((_unref(titlePatterns)[template.id]) = $event),
                          type: "text",
                          maxlength: "250"
                        }, null, 8, _hoisted_79), [
                          [
                            _vModelText,
                            _unref(titlePatterns)[template.id],
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(selectedTemplates).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                  _createElementVNode("h2", null, _toDisplayString(_unref(t)("documentBatch.previewDocuments")), 1),
                  _createElementVNode("p", _hoisted_81, _toDisplayString(_unref(t)("documentBatch.previewHint")), 1),
                  _createElementVNode("label", _hoisted_82, [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)("documentBatch.previewEmployee")), 1),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((previewProfileId).value = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profiles.value, (profile) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: profile.id,
                          value: profile.id
                        }, _toDisplayString(profile.fullName), 9, _hoisted_83))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, previewProfileId.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_84, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedTemplates), (template) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: template.id,
                        class: "batch-preview-item"
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("strong", null, [
                            _createTextVNode(_toDisplayString(template.name) + " ", 1),
                            (_unref(isPackageMode))
                              ? (_openBlock(), _createElementBlock("small", _hoisted_85, _toDisplayString(templateRoleLabel(template)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("small", null, _toDisplayString(previewDocumentName(template)), 1)
                        ]),
                        _createVNode(_component_Button, {
                          type: "button",
                          variant: "default",
                          onClick: ($event: any) => (openTemplatePreview(template))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)("docForm.previewFilledTemplate")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(activeUploadedFiles).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                  _createElementVNode("h2", null, _toDisplayString(_unref(t)("documentBatch.uploadedFiles")), 1),
                  _createElementVNode("p", _hoisted_87, _toDisplayString(_unref(t)("documentBatch.uploadedFilesHint")), 1),
                  _createElementVNode("div", _hoisted_88, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeUploadedFiles), (file) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: file.key
                      }, [
                        _createElementVNode("span", null, [
                          _createElementVNode("strong", null, _toDisplayString(file.name), 1),
                          _createElementVNode("small", null, _toDisplayString(formatFileSize(file.size)), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_89, [
            _createElementVNode("div", _hoisted_90, [
              _createElementVNode("h2", null, _toDisplayString(_unref(t)("documentBatch.review")), 1),
              _createElementVNode("dl", _hoisted_91, [
                _createElementVNode("div", null, [
                  _createElementVNode("dt", null, _toDisplayString(_unref(t)("documentBatch.name")), 1),
                  _createElementVNode("dd", null, _toDisplayString(_unref(config).name), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("dt", null, _toDisplayString(_unref(t)("documentBatch.employees")), 1),
                  _createElementVNode("dd", null, _toDisplayString(profiles.value.length), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("dt", null, _toDisplayString(_unref(t)("documentBatch.templates")), 1),
                  _createElementVNode("dd", null, _toDisplayString(_unref(selectedTemplates).length), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("dt", null, _toDisplayString(_unref(t)("documentBatch.uploadedFiles")), 1),
                  _createElementVNode("dd", null, _toDisplayString(_unref(activeUploadedFiles).length), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("dt", null, _toDisplayString(_unref(t)("documentBatch.creationFormat")), 1),
                  _createElementVNode("dd", null, _toDisplayString(_unref(isPackageMode)
                  ? _unref(t)("documentBatch.packageFormat")
                  : _unref(t)("documentBatch.separateFormat")), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("dt", null, _toDisplayString(_unref(t)("documentBatch.totalDocuments")), 1),
                  _createElementVNode("dd", null, _toDisplayString(_unref(totalDocuments)), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("dt", null, _toDisplayString(_unref(t)("documentBatch.totalFiles")), 1),
                  _createElementVNode("dd", null, _toDisplayString(_unref(totalFiles)), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("dt", null, _toDisplayString(_unref(t)("documentBatch.mode")), 1),
                  _createElementVNode("dd", null, _toDisplayString(_unref(config).sendForExecution
                  ? _unref(t)("documentBatch.sendMode")
                  : _unref(t)("documentBatch.draftMode")), 1)
                ])
              ])
            ]),
            (isCreating.value || results.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                  _createElementVNode("div", _hoisted_93, [
                    _createElementVNode("h2", null, _toDisplayString(_unref(t)("documentBatch.progress")), 1),
                    _createElementVNode("strong", null, _toDisplayString(_unref(completedCount)) + " / " + _toDisplayString(_unref(totalDocuments)), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "batch-progress",
                    role: "progressbar",
                    "aria-valuenow": _unref(progressPercent),
                    "aria-valuemin": "0",
                    "aria-valuemax": "100"
                  }, [
                    _createElementVNode("span", {
                      style: _normalizeStyle({ width: `${_unref(progressPercent)}%` })
                    }, null, 4)
                  ], 8, _hoisted_94),
                  _createElementVNode("div", _hoisted_95, [
                    _createElementVNode("span", _hoisted_96, _toDisplayString(_unref(t)("documentBatch.successful")) + ": " + _toDisplayString(_unref(successCount)), 1),
                    (_unref(failureCount))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_97, _toDisplayString(_unref(t)("documentBatch.failed")) + ": " + _toDisplayString(_unref(failureCount)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (_unref(failureCount))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(failedResults), (result) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: result.itemKey
                          }, [
                            _createElementVNode("strong", null, _toDisplayString(result.userName) + " — " + _toDisplayString(result.templateName), 1),
                            _createElementVNode("span", null, _toDisplayString(result.error), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(failureCount) && !isCreating.value)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 1,
                        variant: "default",
                        onClick: retryFailed
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)("documentBatch.retryFailed")), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_unref(creationFinished) && !_unref(failureCount))
              ? (_openBlock(), _createElementBlock("div", _hoisted_99, _toDisplayString(_unref(t)("documentBatch.completed")), 1))
              : _createCommentVNode("", true)
          ])),
    _createElementVNode("div", _hoisted_100, [
      (step.value > 1 && !isCreating.value)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            variant: "default",
            onClick: previousStep
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.back")), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (step.value < 3)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            disabled: isLoading.value,
            onClick: nextStep
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(isLoading.value ? _unref(t)("common.loading") : _unref(t)("common.next")), 1)
            ]),
            _: 1
          }, 8, ["disabled"]))
        : (!results.value.length)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 2,
              disabled: isCreating.value,
              onClick: createBatch
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("documentBatch.create")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : (_unref(creationFinished))
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 3,
                onClick: _cache[24] || (_cache[24] = ($event: any) => (_unref(router).push({ name: 'DocumentList' })))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("documentBatch.toDocuments")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
    ]),
    _createVNode(Modal, {
      show: previewModalIsOpen.value,
      title: previewDocumentTitle.value,
      wide: "",
      onClose: closeTemplatePreview
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_101, [
          _createElementVNode("span", null, [
            _createElementVNode("strong", null, _toDisplayString(_unref(t)("documentBatch.employee")) + ":", 1),
            _createTextVNode(" " + _toDisplayString(previewEmployeeName.value), 1)
          ]),
          _createElementVNode("span", null, [
            _createElementVNode("strong", null, _toDisplayString(_unref(t)("documentBatch.templates")) + ":", 1),
            _createTextVNode(" " + _toDisplayString(previewTemplateName.value), 1)
          ])
        ]),
        (previewModalIsOpen.value && activePreviewKey.value)
          ? (_openBlock(), _createBlock(_unref(Editor), {
              key: activePreviewKey.value,
              id: `batch-preview-${activePreviewKey.value}`,
              class: "batch-preview-editor",
              init: batchPreviewEditorConfig,
              "tinymce-script-src": _unref(tinyMceScriptSrc),
              modelValue: previewHtml.value,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((previewHtml).value = $event)),
              onChange: markActivePreviewAsEdited
            }, null, 8, ["id", "tinymce-script-src", "modelValue"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_102, [
          _createVNode(_component_Button, {
            type: "button",
            variant: "default",
            onClick: closeTemplatePreview
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.close")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show", "title"]),
    _createVNode(Modal, {
      show: showPreviewConflictModal.value,
      title: _unref(t)('docForm.previewConflictTitle'),
      onClose: _cache[28] || (_cache[28] = ($event: any) => (resolvePreviewConflict(null)))
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_103, _toDisplayString(_unref(t)("docForm.previewConflictMessage")), 1),
        _createElementVNode("p", _hoisted_104, _toDisplayString(_unref(t)("docForm.previewConflictHint")), 1),
        _createElementVNode("div", _hoisted_105, [
          _createVNode(_component_Button, {
            type: "button",
            variant: "default",
            onClick: _cache[26] || (_cache[26] = ($event: any) => (resolvePreviewConflict('KEEP')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("docForm.previewConflictKeep")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            type: "button",
            onClick: _cache[27] || (_cache[27] = ($event: any) => (resolvePreviewConflict('REBUILD')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("docForm.previewConflictRebuild")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show", "title"])
  ]))
}
}

})